export const shadow = (init = '', html = '')=>(superclass)=>class extends superclass {
            root = (()=>{
                const root = this.attachShadow(typeof init === 'object' ? init : {
                    mode: 'open'
                });
                root.innerHTML = typeof init === 'string' ? init : html;
                return root;
            })();
        }
;
